import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: '[foundation-type-3]',
    templateUrl: './foundation-type-3.component.html',
    styleUrl: './foundation-type-3.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FoundationType3Component {
  public height = input<number>();
}
